import TagTypes from '../../constants/TagTypes';
import { tags_type_count_$gte } from '../../utils/query-helpers';

const REQUIRED_FIELDS = {
  $and: [
    // Must provide activity type and description
    {
      activityId: {
        $null: false
      },
      description: {
        $not: '',
        $null: false
      }
    },
    // Must specify a date
    {
      $or: [
        {
          specificDate: 'Yes',
          date: {
            $null: false
          }
        },
        {
          specificDate: 'No',
          startDate: {
            $null: false
          },
          endDate: {
            $null: false
          }
        }
      ]
    },
    // Must specify a participant
    {
      ...tags_type_count_$gte(TagTypes.Participant, 1)
    },
    // Must specify a method of interaction
    {
      ...tags_type_count_$gte(TagTypes.InteractionType, 1)
    }
  ]
}

export default REQUIRED_FIELDS;
